import { createSelector } from 'reselect';
import { CONTENT_ITEM_SINGLE } from 'config/types/path';
import { getPathType } from './getMatch';

const getIsArticlePage = createSelector(
  getPathType,
  (pathType) => pathType === CONTENT_ITEM_SINGLE,
);

export default getIsArticlePage;
